import React, { useState } from "react";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";

import Calendar from "images/icons/calendar-icon.inline.svg";
import CtaButton from "components/shared/buttons/ctaButton";
/**
 * 
 * @param {prefill} 
 * @returns
 * @description a small component to render calendly on the site
 * @documentaion https://www.npmjs.com/package/react-calendly / https://help.calendly.com/hc/en-us/articles/223147027-Embed-options-overview?tab=advanced#3
 *
  url: https://calendly.com/EVENT_ID/EVENT_LINK?hide_gdpr_banner=1
  prefill: {
    name: "John Doe",
    email: "john@doe2.com",
    customAnswers: {
      a1: "Yes",
      a2: "At the Starbucks on 3rd and 16th"
    }
  }
  utm: {
    utmCampaign: "Spring Sale 2019",
    utmSource: "Facebook",
    utmMedium: "Ad",
    utmContent: "Shoe and Shirts",
    utmTerm: "Spring"
  }

 **/

const EmbedCalendlyEvent = ({
  eventID = "gvi-consultation",
  eventLink = "",
  prefill = {},
  utm = {},
  calendlyEventListener = () => {}
}) => {
  useCalendlyEventListener({
    onProfilePageViewed: (e) => calendlyEventListener(e.data),
    onDateAndTimeSelected: (e) => calendlyEventListener(e.data),
    onEventTypeViewed: (e) => calendlyEventListener(e.data),
    onEventScheduled: (e) => calendlyEventListener(e.data)
  });

  return (
    <>
      {eventID && (
        <InlineWidget
          url={`https://calendly.com/${eventID}/${eventLink}?hide_gdpr_banner=1`}
          prefill={prefill}
          utm={utm}
        />
      )}
    </>
  );
};

export const PopupCalendlyEvent = ({
  eventID = "gvi-consultation",
  eventLink = "",
  prefill = {},
  utm = {},
  ctaButton = <></>,
  iconColor = "",
  headingTitle = "",
  headingBlock = <></>,
  description = <></>,
  containerClass = "flex flex-col gap-3 w-full items-center mt-10 justify-center overflow-scroll h-80 sm:h-auto",
  setCalendlyOverlay,
  children,
  calendlyEventListener = () => {}
}) => {
  const [openModal, setOpenModal] = useState(false);

  useCalendlyEventListener({
    onProfilePageViewed: (e) => calendlyEventListener(e.data),
    onDateAndTimeSelected: (e) => calendlyEventListener(e.data),
    onEventTypeViewed: (e) => calendlyEventListener(e.data),
    onEventScheduled: (e) => calendlyEventListener(e.data)
  });

  return (
    <div className={containerClass}>
      {eventID && !openModal && (
        <>
          <CtaButton
            preset={"primary"}
            ctaLabel={
              <div className="flex gap-2 items-center">
                <Calendar
                  className={`h-6 w-6 shrink-0 fill-current ${iconColor}`}
                />
                {headingTitle}
              </div>
            }
            labelClass="text-base leading-genericCta font-bold pr-2"
            extraButtonStyle={"w-full"}
            onClick={() => {
              setOpenModal(true);
              setCalendlyOverlay(true);
            }}
            showAsButton={true}
            showArrowIcon={false}
          />

          {description}

          {children}
        </>
      )}

      {eventID && openModal && (
        <>
          <div className="sm:px-6 pt-6 absolute top-0 left-0 bottom-6 right-0 overflow-auto">
            {headingBlock}

            <InlineWidget
              url={`https://calendly.com/${eventID}/${eventLink}?hide_gdpr_banner=1`}
              prefill={prefill}
              utm={utm}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default EmbedCalendlyEvent;
